import { gql } from "@apollo/client";

export const PREQUALIFY = gql`
  mutation Prequalify($data: PrequalifyInput!) {
    prequalify(data: $data) {
      id
      status
      firstName
      lastName
      email
      phone
      street
      city
      state
      zip
      dateOfBirth
      petId
      limit
      balance
      checkedAt
      expiresAt
      scratchReference
      errorReason
      errors {
        field
        messages
      }
      selectedPlanId
      selectedBilling
    }
  }
`;
